<template>
    <div class="bindTags">
        <Modal v-model="modal"
               :title="autoSubmit ? $t('绑定标签') : $t('添加标签')"
               :mask-closable="false"
               width="750"
               @on-cancel="cancel">
            <!-- 展示已选择标签 -->
            <Row class="bindTags-showTags">
                <Col :span="3"
                     style="text-align:right;"> {{$t('标签')}}:
                </Col>
                <Col :span="21"
                     style="padding:0 10px;">
                <!-- 添加标签 -->
                <div class="top-tags">
                    <Icon type="icon-increase-1-o"
                          class="icon-increase-1-o"
                          @click="changeAddTag(true)"
                          v-show="!status"
                          style="color:#3498dc;font-size:18px;cursor:pointer;" />
                    <span v-show="status">
                        <AutoComplete v-model.trim="valueKey"
                                      size="small"
                                      :data="autoSearchKey"
                                      :filter-method="filterMethod"
                                      :placeholder="$t('标签键')"
                                      @on-change="validateKey = false"
                                      style="width:80px">
                        </AutoComplete>
                        :
                        <AutoComplete v-model.trim="valueValue"
                                      size="small"
                                      :data="autoSearchValue"
                                      :filter-method="filterMethod"
                                      :placeholder="$t('标签值')"
                                      @on-change="validateKey = false"
                                      style="width:80px">
                        </AutoComplete>
                        <Icon type="md-checkmark"
                              @click="addTag"
                              style="cursor:pointer;color:#1ebd62;font-size:18px;" />
                        <Icon type="md-close"
                              @click="changeAddTag(false)"
                              style="cursor:pointer;color:red;font-size:18px;" />
                        <p v-show="validateKey"
                           style="color: #ed4014;">{{ errTips }}</p>
                    </span>
                </div>
                <Tag v-for="(item,i) in selected"
                     :key="'popular'+i"
                     :color="item.rgbCode"
                     closable
                     @on-close="removeSelect(item)">
                    <span>
                        {{item.tagName}}
                        <span v-if="item.tagValue">:{{item.tagValue}}</span>
                    </span>
                </Tag>
                </Col>
            </Row>
            <!-- 最热可选标签 -->
            <Row class="bindTags-hotTags">
                <Col :span="3"
                     style="text-align:right;"> {{$t('热门标签')}}:
                </Col>
                <Col :span="21"
                     style="padding:0 10px;">
                <loading v-if="dataLoading" />
                <Tag v-for="(item,i) in popular"
                     v-if="!dataLoading"
                     :key="'popular'+i"
                     :color="item.rgbCode">
                    <span style="display:inline-block;width:100%;height:100%;"
                          @click="selectPopTag(item)">
                        {{item.tagName}}
                        <span v-if="item.tagValue">:{{item.tagValue}}</span>
                    </span>
                </Tag>
                </Col>
            </Row>
            <div slot="footer">
                <Button type="text"
                        @click="cancel">取消</Button>
                <Button type="primary"
                        :loading="loading"
                        @click="ok">
                    <span v-show='!loading'>确定</span>
                    <span v-show='loading'>保存中</span>
                </Button>
            </div>
        </Modal>
    </div>
</template>

<script type="text/ecmascript-6">
import api from '@/service/api.js'
import loading from '@/views/components/basic/loading.vue'
export default {
    props: {
        // 是否点击确定自動提交
        autoSubmit: {
            type: Boolean,
            default: true
        },
        // 是否开启tag自动检索
        autoSearch: {
            type: Boolean,
            default: true
        },
        // 已经绑定的标签
        bindedTags: {
            type: Array
        }
    },
    components: {
        loading
    },
    data () {
        return {
            // 键值 key 验证
            validateKey: false,
            // 弹出框状态
            modal: false,
            // 添加input状态
            status: false,
            // 原始热门标签
            origPopTags: [],
            popular: [],
            // 所有标签
            alltags: [],
            // 已选标签
            selected: [],
            // 当前选择的标签
            selectedTag: '',
            loading: false,
            dataLoading: false,
            // 标签key
            valueKey: '',
            // 标签值
            valueValue: '',
            // 错误提示文案
            errTips: '',
            // 联想tags key
            autoSearchKey: [],
            // 联想tags 值
            autoSearchValue: []
        }
    },
    methods: {
        // 获取热门标签
        getHotTags () {
            this.axios.get(api.GET_TAGS_POPULAR).then(result => {
                this.dataLoading = false
                const res = result.dataList
                this.popular = res
                this.origPopTags = res
                this.selected.length > 0 && (this.popular = this.popular.filter(item => {
                    let state = true
                    this.selected.forEach((r, i) => {
                        r.tagName === item.tagName && r.tagValue.trim() === (item.tagValue || '').trim() && r.rgbCode === item.rgbCode && (state = false)
                    })
                    return state
                }))
            }).catch(e => {
                this.dataLoading = false
            })
        },
        // 获取所有标签
        getTags () {
            this.axios.get(api.TAGS).then(res => {
                this.alltags = res
                this.selected.length > 0 && (this.alltags = this.alltags.filter(item => {
                    let state = true
                    this.selected.forEach((r, i) => {
                        r.tagName === item.tagName && r.tagValue === item.tagValue && r.rgbCode === item.rgbCode && (state = false)
                    })
                    return state
                }))
                this.autoSearchKey = [...new Set(this.alltags.map(item => item.tagName))]
                this.autoSearchValue = [...new Set(this.alltags.map(item => item.tagValue))]
            })
        },
        // 选择热门标签
        selectPopTag (obj) {
            this.popular = this.popular.filter(item => item !== obj)
            this.selected.unshift(obj)
        },
        // 移除选择
        removeSelect (obj) {
            this.selected = this.selected.filter(item => item !== obj)
            // 判断是否是热门标签
            const isYSRMBQ = this.origPopTags.filter(item => item.tagName === obj.tagName && item.tagValue === obj.tagValue)
            isYSRMBQ.length > 0 && this.popular.push(obj)
        },
        // 显示添加标签
        changeAddTag (status) {
            this.status = status
            if (!status) {
                this.valueKey = ''
                this.valueValue = ''
                this.validateKey = false
            }
        },
        // 添加选择的tag
        addTag () {
            this.validateKey = false
            if (!this.valueKey) {
                this.validateKey = true
                this.errTips = '标签键不能为空'
            }
            this.selected.map(item => {
                if (item.tagName === this.valueKey && item.tagValue === this.valueValue) {
                    this.validateKey = true
                    this.errTips = '不能添加重复的标签'
                }
            })
            // 校验不过, 标签键为空 || 已经选择了此键
            if (this.validateKey) {
                return
            }
            // 所选的键是热门键里面的，删除热门键
            this.popular = this.popular.filter(item => {
                if (!(item.tagName === this.valueKey && item.tagValue === this.valueValue)) {
                    return item
                }
            })
            // tagId转换成tag对象
            const tagObj = this.alltags.filter(item => item.tagName === this.valueKey && item.tagValue === this.valueValue)
            if (tagObj.length > 0) {
                this.selected.unshift(tagObj[0])
                this.alltags = this.alltags.filter(item => item.tagId !== tagObj[0].tagId)
            } else {
                const colors = ['#9F9BB7', '#FF615A', '#6EBBE5', '#94CC68', '#9872C2', '#ECC53A', '#42C2B4', '#B20005']
                const index = Math.floor(Math.random() * colors.length)
                this.selected.unshift({ tagName: this.valueKey, tagValue: this.valueValue, rgbCode: colors[index] })
            }
            this.changeAddTag(false)
        },
        // 选择键
        hasSelectKey (obj) {
            this.selectedTag = obj
        },
        // 筛选大小写不敏感
        filterMethod (value, option) {
            return option && value && option.toUpperCase().indexOf(value.toUpperCase()) !== -1
        },
        close () {
            this.status = false
            this.modal = false
        },
        open (id, tags, objType) {
            this.dataLoading = true
            this.objId = id
            this.selected = JSON.parse(JSON.stringify(tags || []))
            this.objType = objType
            this.modal = true
            this.getHotTags()
            this.getTags()
        },
        change (state) {
            !state && (this.selected = [])
        },
        ok () {
            const arr = []
            // fixed bug  10193 （v3.3.4）共通_添加标签未确认状态下可点击确认
            if (this.status) {
                this.$Message.error('您还有数据信息未保存')
                return
            }
            this.selected.forEach((r, i) => {
                const obj = {
                    objType: this.objType,
                    objId: this.objId,
                    rgbCode: r.rgbCode,
                    tagName: r.tagName,
                    tagValue: r.tagValue
                }
                r.tagId && (obj.tagId = r.tagId)
                arr.unshift(obj)
            })
            if (arr.length >= 0) {
                this.$emit('getSelects', arr)
            }
            if (this.autoSubmit) {
                this.loading = true
                this.axios.post(this.urlFormat(api.POST_BIND_TAGS, false, [this.objType, this.objId]), arr).then(res => {
                    this.$emit('refresh')
                    this.loading = false
                    this.close()
                }).catch(() => {
                    this.loading = false
                })
            } else {
                this.close()
            }
        },
        cancel () {
            this.close()
        }
    }
}
</script>

<style scoped lang="less">
.top-tags {
    padding-bottom: 6px;
}

.bindTags-showTags {
    padding-top: 16px;
    padding-bottom: 16px;
}

.bindTags-hotTags {
    border-top: 1px dashed #e9e9e9;
    padding-top: 16px;
}

.bindTags .ivu-tag-text {
    display: inline-block;
}
</style>
<style lang="less">
.ivu-select-dropdown {
    width: auto !important;
}

.ivu-select-dropdown-list::-webkit-scrollbar {
    width: 0 !important;
    display: none !important;
}
.ivu-select-dropdown-list {
    -ms-overflow-style: none !important;
}
.ivu-select-dropdown-list {
    overflow: -moz-scrollbars-none;
}

.ivu-select-dropdown-list {
    max-height: 200px;
    overflow-y: scroll;
    overflow-x: hidden;
}
.ivu-tag {
    height: 23px;
    line-height: 23px;
    cursor: default;
}
</style>
